module.exports = __webpack_public_path__ + "img/email-sent.1e131b52.png";